import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_24: FaireProductEntity = {
  token: "atc_fs_24",
  type: "product",
  name: "Bergamot Pocket Sanitizer",
  brandName: "Noshinku",
  brandToken: "noshinku",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fd3d710ef1b00e98253d2e76765c2cb111c43daac1870e05e581857ef0c3ccd1.webp",
  priceDollars: 11,
  msrpDollars: 22,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
